var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"base-button",class:{
    'primary': _vm.type === 'primary',
    'secondary': _vm.type === 'secondary',
    dark: _vm.dark
  },on:{"click":function($event){return _vm.$emit(_vm.emitMessage)}}},[(_vm.iconName)?_c('icon',{staticClass:"button-icon",class:{
      'rotate-icon': _vm.rotateIcon,
    },attrs:{"name":_vm.iconName,"variant":_vm.iconVariant}}):_vm._e(),_vm._v(" "),_c('span',{class:{'all-upper-case': _vm.upperCase}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }